var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('transition',{attrs:{"mode":"out-in","name":"fade-transform"}},[_c('keep-alive',[_c('v-card',{staticClass:"layout-card-content",attrs:{"elevation":0,"tile":""}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }